import request from '@/utils/request'


// 查询菜单列表
export function listRole(para) {
  return request({
    url: '/system/role/pagelist',
    method: 'post',
    data: para
  })
}
/***
 * 增加角色
 */
export function addRole(para){
  return request({
    url: '/system/role/add',
    method: 'post',
    data: para
  })
}

/**
 * 更新角色
 * @returns 
 */

export function updateRole(para){
  return request({
    url: '/system/role/edit',
    method: 'post',
    data: para
  })
}
/**
 * 获取角色详情
 * @param {*} roleId 
 * @returns 
 */
export function getRole(roleId){
  return request({
    url: '/system/role/detail/'+roleId,
    method: 'get',
    
  })
}
export function delRole(roleIds){
  return request({
    url: '/system/role/remove/'+roleIds,
    method: 'get',
    
  })
}

export function changeRoleStatus(para){
  return request({
    url: '/system/role/changeStatus',
    method: 'post',
    data: para
  })
}

// 查询角色已授权用户列表
export function allocatedUserList(params) {
  return request({
    url: '/system/user/allocatedList',
    method: 'post',
    data: params
  })
}

// 查询角色未授权用户列表
export function unallocatedUserList(params) {
  return request({
    url: '/system/user/unallocatedList',
    method: 'post',
    params: params
  })
}

// 取消用户授权角色
export function authUserCancel(params) {
  return request({
    url: '/system/user/cancelAllocated',
    method: 'post',
    data: params
  })
}

// 批量取消用户授权角色
export function authUserCancelAll(params) {
  return request({
    url: '/system/user/cancelAllAllocated',
    method: 'post',
    data:params
  })
}

// 授权用户选择
export function authUserSelectAll(data) {
  return request({
    url: '/system/role/authUser/selectAll',
    method: 'put',
    params: data
  })
}